import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { CoreContentState, TranslationSelector } from "@obg/ngx.core.content";
import { filter, take, tap } from "rxjs/operators";

@Component({
	selector: "obg-seo-proposition-messages",
	templateUrl: "./seo-proposition-messages.component.html",
	encapsulation: ViewEncapsulation.None,
})
export class SeoPropositionMessages implements OnInit {
	@Input() desktopContent = false;

	readonly CRS_SEO_PROPOSITIONS_MOBILE_KEY = "general.seo.proposition-messages.mobile";
	readonly CRS_SEO_PROPOSITIONS_DESKTOP_KEY = "general.seo.proposition-messages.desktop";
	seoPropositions: string[] | undefined;

	constructor(
		private store: Store<CoreContentState>,
		private translationSelector: TranslationSelector
	) {}

	ngOnInit() {
		const crsSeoPropositionKey = this.desktopContent
			? this.CRS_SEO_PROPOSITIONS_DESKTOP_KEY
			: this.CRS_SEO_PROPOSITIONS_MOBILE_KEY;

		this.store
			.pipe(
				this.translationSelector.getByKey$(crsSeoPropositionKey),
				take(1),
				filter((data) => !!data && data !== crsSeoPropositionKey),
				tap((data: string) => (this.seoPropositions = data.split(";")))
			)
			.subscribe(); // eslint-disable-line rxjs/no-ignored-subscription
	}

	/**
	 * Track by helper for ngFor
	 * @param index - index from ngFor
	 */
	trackByFn(index: number) {
		return index;
	}
}
